import styled from 'styled-components'
import {media} from '@/src/config/theme'

export const ThirdPartyWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;

  flex-direction: column;

  @media ${media.sm} {
    flex-direction: row;
  }
`
